import React from 'react';
import { eeRights, zywaveUserRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { Redirect } from 'react-router-dom';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import Cookies from 'js-cookie';

export interface AppRedirectProps {
  userRoles: SupportedUserRoles[];
}

const AppRedirect: React.FC<AppRedirectProps> = ({ userRoles }) => {
  if (eeRights(userRoles)) {
    return <Redirect to="/employee" />;
  }

  if (zywaveUserRights(userRoles)) {
    const groupId = Cookies.get('groupId');

    return <Redirect to={`/zywave-group/${groupId}`} />;
  }

  return <Redirect to="/dashboard" />;
};

export default AppRedirect;
